export default function getCheapestPackageByDuration<TPackage extends Pick<App.Package, 'duration' | 'price'>>(
  packages: ReadonlyArray<TPackage>,
  duration: number,
): TPackage | undefined {
  return packages.reduce<TPackage | undefined>((cheapestPackage, pkg) => {
    if (pkg.duration !== duration || pkg.price <= 0) {
      return cheapestPackage
    }

    if (!cheapestPackage || pkg.price < cheapestPackage.price) {
      return pkg
    }

    return cheapestPackage
  }, undefined)
}
